import {
  CaretDown,
  Chats,
  Code,
  LineVertical,
  Toolbox,
  UserCircle,
  Dna,
  ClipboardText,
} from '@phosphor-icons/react';
import { NavLink } from 'react-router-dom';
import AccountDropdown from './AccountDropdown';
import { useAuth } from '@Context/CognitoAuthProvider';
const NavlinksLarge = () => {
  const { user } = useAuth();
  const isAdmin = user?.admin ?? false;

  const showAccountDropdown = () => {
    const dropdown = document.getElementById('account-dropdown');
    if (dropdown) {
      dropdown.classList.toggle('hidden');
      dropdown.classList.add('flex');
    }
  };

  return (
    <div className="relative flex flex-row items-center gap-x-1">
      <div className="flex items-center border-neutral-400 font-inter text-xs">
        <NavLink to="/home">
          {({ isActive }) => (
            <div
              className={`${isActive ? 'border-b-2 font-extrabold text-white' : 'font-semibold text-neutral-400'} flex flex-row items-center justify-center gap-1 px-3 py-0.5`}
            >
              <Code size={20} weight="bold" />
              <span>Generator</span>
            </div>
          )}
        </NavLink>
        <NavLink to="/gpt" data-testid="ask-ai-page" /*AskAI on NavBar*/>
          {({ isActive }) => (
            <div
              className={`${isActive ? 'border-b-2 font-bold text-white' : 'font-semibold text-neutral-400'} flex flex-row items-center justify-center gap-1 px-3 py-0.5`}
            >
              <Chats size={20} weight="bold" />
              <span>Ask AI</span>
            </div>
          )}
        </NavLink>
        <NavLink to="/prompts" data-testid="prompts-page">
          {({ isActive }) => (
            <div
              className={`${isActive ? 'border-b-2 font-bold text-white' : 'font-semibold text-neutral-400'} flex flex-row items-center justify-center gap-1 px-3 py-0.5`}
            >
              <Toolbox size={20} weight="bold" />
              <span>Prompts</span>
            </div>
          )}
        </NavLink>
        {isAdmin && user?.profile?.aha_api_key !== '' && (
          <>
            <NavLink to="/analyzer">
              {({ isActive }) => (
                <div
                  className={`${
                    isActive
                      ? 'border-b-2 font-bold text-white'
                      : 'font-semibold text-neutral-400'
                  } flex flex-row items-center justify-center gap-1 px-3 py-0.5`}
                >
                  <Dna size={20} weight="bold" />
                  <span>Analyzer</span>
                </div>
              )}
            </NavLink>
          </>
        )}

        <NavLink to="/analyzer-reports">
          {({ isActive }) => (
            <div
              className={`${
                isActive
                  ? 'border-b-2 font-bold text-white'
                  : 'font-semibold text-neutral-400'
              } flex flex-row items-center justify-center gap-1 px-3 py-0.5`}
            >
              <ClipboardText size={20} weight="bold" />
              <span>Analyzer Reports</span>
            </div>
          )}
        </NavLink>

        <NavLink to="/artillery-reports">
          {({ isActive }) => (
            <div
              className={`${
                isActive
                  ? 'border-b-2 font-bold text-white'
                  : 'font-semibold text-neutral-400'
              } flex flex-row items-center justify-center gap-1 px-3 py-0.5`}
            >
              <ClipboardText size={20} weight="bold" />
              <span>Artillery Reports</span>
            </div>
          )}
        </NavLink>
      </div>

      <LineVertical size={30} color="white" weight="bold" />
      <div
        className="flex cursor-pointer flex-row items-center"
        onClick={showAccountDropdown}
      >
        <UserCircle size={30} color="white" weight="fill" />
        <CaretDown size={15} color="white" weight="thin" />
      </div>

      <AccountDropdown />
    </div>
  );
};

export default NavlinksLarge;
